import { useRouter } from 'nextjs-toploader/app'

import { Button } from '@/components/ui/tailwind/Button'
import { useSiteSettings } from '@/hooks/useSiteSettings'
import { useTranslations } from '@/hooks/useTranslations'

export const SignUpButton = () => {
  const { language } = useTranslations()
  const { getLinkByName } = useSiteSettings()
  const { push } = useRouter()
  const link = getLinkByName('product.button.signUp_link')

  const handleClick = () => {
    if (link?.url) {
      push(link.url)
    }
  }

  return (
    <Button variant="primary" onClick={handleClick} data-testid="product-signupButton" className="whitespace-nowrap">
      {link?.externalName?.[language]}
    </Button>
  )
}
